import { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getpastWebinarYears } from '../../services/pastWebinarReportServices';
import { Modal, Button, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty } from '../../utils/common';

const Pastwebinarreport = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '', year: '', pw_title: '', pw_report_desc: '', meta_title: '', meta_description: ''});
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pastWebinarYears, setpastWebinarYears] = useState([]);
  
  const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};
  
  const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
];

  // Fetch data list
  const fetchData = useCallback(async () => {
    setLoading(true);
     try { 
    const data = await getData();
    setDataList(data);
     }
    catch (error) { 
      console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } 
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

   useEffect(() => {
        const fetchpastWebinarYears = async () => {
          try {
            const data = await getpastWebinarYears(); // Fetch data from the service
            setpastWebinarYears(data); // Set the types in state
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
     
        fetchpastWebinarYears();
      }, []);

   // Validate form data
  const validateForm = () => {
  const newErrors = {};
  if (!form.year) newErrors.year = "Year is required";
  if (!form.pw_title) newErrors.pw_title = "Title is required";
  if ( isQuillContentEmpty(form.pw_report_desc.trim())) newErrors.pw_report_desc = "Description is required";
  if (!form.meta_title) newErrors.meta_title = "Meta Title is required";
  if (!form.meta_description) newErrors.meta_description = "Meta Description is required";
  if (form.meta_title.length < 20 || form.meta_title.length > 70) newErrors.meta_title = "Meta Title should be between 20 and 70 characters";
  if (form.meta_description.length < 70 || form.meta_description.length > 160) newErrors.meta_description = "Meta Description should be between 70 and 160 characters";
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
}

  const handleChange = (e) => {
    const { name, value } = e.target;
    try{
       let updatedErrors = { ...errors };
    if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors(updatedErrors);
    }
    catch (error) {
      console.error('Error in handleChange:', error);
    }
  };
  // Handle change for Quill editor
  const handleDescriptionChange = (value) => {
    setErrors((prev) => ({ ...prev, pw_report_desc: isQuillContentEmpty(value) ? 'Description is required' : '' }));
    setForm((prev) => ({ ...prev, pw_report_desc: value}));
  };

  const handleSubmit = async (e) => {
     e.preventDefault();
    if (!validateForm()) {
        return
      }
    let response;
    if (modalType === 'add') {
      response = await addData(form);
      if (response.status === 200||201) {
        toast.success("Added Successfully!", {
          position: 'top-right',
          autoClose: 3000,
        });
      } 
      else{
          toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
      console.log((response?.message || "Failed to process request."));
      }
    } else if (modalType === 'edit') {
      response =  await updateData(form);
      if (response && response.status === 200) {
        toast.success("Updated Successfully!", { position: 'top-right',autoClose: 3000});
          }
      else{
      toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
      console.log((response?.message || "Failed to process request."));
          }
    }
    fetchData();  // Re-fetch data after adding/editing
    setShowModal(false);
  };

  const handleDelete = async () => {
    try{
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
      toast.success("Deleted Successfully!", {
                        position: 'top-right',
                        autoClose: 3000,
                      });
      }
    }
    catch (error) {
        console.error('Error deleting data:', error);
      }
  };

  const openModal = (type, data = { id: '', year: '', pw_title: '', pw_report_desc: '', meta_title: '', meta_description: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };
  
  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered =  dataList.filter(
      (data) =>
      data.pw_title.toLowerCase().includes(searchText.toLowerCase()) ||
      data.year.toLowerCase().includes(searchText.toLowerCase())
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData;
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '80px',
    },
    {
      name: 'year',
      selector: (row) => row.year,
      cell: (row) => (
            <span title={row.year}>
              {row.year}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Past Conference Title',
      selector: (row) => row.pw_title,
      cell: (row) => (
            <span title={row.pw_title}>
              {row.pw_title}
            </span>
          ),
      sortable: true,
    },
    
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
    },
  ];
  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Past Events Pages / Past Webinar <b>/ Webinar Report</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" show={showModal} onHide={() => setShowModal(false)} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
              <div className="row">
                <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Past Webinar Year<small className='text-danger form-label-note'> * </small></Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="year" value={form.year} onChange={handleChange}  isInvalid={!!errors.year}>
                    <option value="">Select Year</option>
                    {pastWebinarYears.map((years) => (
                        <option key={years.year} value={years.year}>
                        {years.display_year}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.year}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Past Webinar Title <small className='text-danger form-label-note'> * </small></Form.Label>
                  <Form.Control type="text" name="pw_title" value={form.pw_title} onChange={handleChange} isInvalid={!!errors.pw_title} />
                  <Form.Control.Feedback type="invalid">{errors.pw_title}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label className='form-label-custom'>Past Webinar Description</Form.Label>
                    <ReactQuill
                        value={form.pw_report_desc}
                        onChange={handleDescriptionChange}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        placeholder="Enter description"
                        className={`react-quill-editor ${errors.pw_report_desc ? 'border border border-1 border-danger rounded' : ''}`}
                    />
                    {errors.pw_report_desc && (
                    <div className="invalid-feedback d-block">
                      {errors.pw_report_desc}
                    </div>
                  )}
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'> Meta Title<small className='text-danger form-label-note'> * </small><small className='text-primary'>Char Limit : 20 -70 | Current Char Count: {form.meta_title.length}</small></Form.Label>
                  <Form.Control as="textarea"  rows={8}  name="meta_title" value={form.meta_title} onChange={handleChange}  isInvalid = {!!errors.meta_title}/>
                  <Form.Control.Feedback type="invalid">{errors.meta_title}</Form.Control.Feedback> 
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Meta Description <small className='text-danger form-label-note'> * </small><small className='text-primary'>Char Limit : 70 -160 | Current Char Count: {form.meta_description.length}</small></Form.Label>
                  <Form.Control as="textarea"  rows={8}  name="meta_description" value={form.meta_description} onChange={handleChange} isInvalid={!!errors.meta_description}  />
                  <Form.Control.Feedback type="invalid">{errors.meta_description}</Form.Control.Feedback>
                </Form.Group>
                
                </div>
              
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" type='submit' > {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
            </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
         </div>
        )}
      </div>
    </div>
  );
};

export default Pastwebinarreport;